import { QueryClient } from '@tanstack/react-query';

export const createAppQueryClient = () => new QueryClient();

export const appQueryClient = createAppQueryClient();
